module.exports = __webpack_public_path__ + "images/basketball1-aaea202b67dfaddb66d18a34378c23f8.jpg";